@layer refine.base {
  :host {
    --_height: var(--password-strength-height, 0.375rem);
    --_gap: var(--password-strength-gap, var(--space-1, 0.25rem));
    --_radius: var(--password-strength-radius, var(--rounded-full));
    --_track-bg: var(--password-strength-track-bg, var(--color-contrast-300, #d1d5db));
    --_track-border: var(--password-strength-track-border, var(--color-contrast-400, #9ca3af));
    --_active-color: var(--password-strength-weak-color, var(--color-warning-500, #f59e0b));

    display: grid;
    gap: var(--space-1, 0.25rem);
    width: 100%;
  }

  :host([data-level='fair']) {
    --_active-color: var(--password-strength-fair-color, var(--color-warning-600, #d97706));
  }

  :host([data-level='good']) {
    --_active-color: var(--password-strength-good-color, var(--color-success-500, #22c55e));
  }

  :host([data-level='strong']) {
    --_active-color: var(--password-strength-strong-color, var(--color-success-600, #16a34a));
  }

  .meter {
    width: 100%;
    min-width: 10rem;
  }

  .segments {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: var(--_gap);
  }

  .segment {
    height: var(--_height);
    min-height: 0.35rem;
    background: var(--_track-bg);
    border: 1px solid var(--_track-border);
    border-radius: var(--_radius);
    transition: var(--_motion-transition, background-color var(--transition-fast), border-color var(--transition-fast));
  }

  .segment.active {
    background: var(--_active-color);
    border-color: var(--_active-color);
  }

  .level-label {
    min-height: 1.25em;
    font-size: var(--password-strength-label-size, var(--text-sm, 0.875rem));
    line-height: 1.25;
    color: var(--password-strength-label-color, currentColor);
  }
}
